import { useCallback, useMemo, useState } from 'react';
import { useGetCollectionReportQuery } from '../../../../api/endpoints/collectionReport';
import { usePermissions } from '../../../../hooks/usePermissions';
import { useLanguage } from '../../../../contexts/LanguageContext';

const useCollectionReportData = () => {
    const { hasAccountingRole, hasAdminRole, hasWarrantyManagerRole } = usePermissions();
    const { getCurrentLanguageId } = useLanguage();
    const languageId = getCurrentLanguageId();

    // Accounting / Admin / WarrantyManager tüm bayileri görür; diğer (bayi) roller yalnızca kendi verisini görür.
    const canSelectDealer = hasAccountingRole() || hasAdminRole() || hasWarrantyManagerRole();
    const isDealerOnly = !canSelectDealer;

    const [filters, setFilters] = useState({
        dealerCode: null,
        year: null,
        currency: null
    });

    const queryParams = useMemo(
        () => ({
            DealerCode: filters.dealerCode || undefined,
            Year: filters.year ?? undefined,
            Currency: filters.currency || undefined
        }),
        [filters]
    );

    const { data, isLoading, isFetching } = useGetCollectionReportQuery(queryParams, {
        refetchOnMountOrArgChange: true
    });

    const rows = useMemo(() => (isFetching ? [] : data?.rows || []), [data, isFetching]);
    const grandTotals = useMemo(() => (isFetching ? [] : data?.grandTotals || []), [data, isFetching]);
    const loading = isLoading || isFetching;

    const exportParams = useMemo(
        () => ({
            DealerCode: filters.dealerCode || undefined,
            Year: filters.year ?? undefined,
            Currency: filters.currency || undefined,
            CompressionType: 0,
            languageId
        }),
        [filters, languageId]
    );

    const handleApplyFilters = useCallback((updated) => {
        setFilters((prev) => ({ ...prev, ...updated }));
    }, []);

    const handleResetFilters = useCallback(() => {
        setFilters({ dealerCode: null, year: null, currency: null });
    }, []);

    return {
        filters,
        rows,
        grandTotals,
        loading,
        exportParams,
        isDealerOnly,
        handleApplyFilters,
        handleResetFilters
    };
};

export default useCollectionReportData;
